import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import { Link } from 'react-router-dom'
import { getLogs } from '../../actions/logsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'

export default function Logs() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

	const {logs, total} = useSelector(state=>state.logs)

    useEffect(() => {
        if (client) {
            dispatch(getLogs(page, limit, search))
        }
    }, [page, limit, search])

    useEffect(() => {
        setTotalRows(total || 0)
    }, [total])

    const columnsLogs = [
        {
            name: t('admin.logs.date'),
            cell: datos =>
                <div>
                    {datos.date.substr(8,2)+'/'+datos.date.substr(5,2)+'/'+datos.date.substr(0,4)+' - '+datos.date.substr(11,8)}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('admin.logs.log'),
            cell: datos =>
                <div>
                    {datos.message}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        }
    ]

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/admin/dashboard">
                        <img src="../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.logs.logs')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5 ">
                <Col>
                    <label className='sd-label-medium'>{t('admin.logs.listlogs')}</label>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="d-flex my-2">
                        <input
                            type="text"
                            className="form-control me-2"
                            placeholder={t("datatables.buscar")}
                            value={searchAux || ""}
                            onChange={e => {
                                setSearchAux(e.target.value);
                                setPage(1);
                            }}
                            onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                        />
                        <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                    </div>
                    {logs?.length > 0
                        ?
                            <CustomDataTable
                                columns={columnsLogs}
                                data={logs}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                searchText={search}
                                onChangeRowsPerPage={(newLimit) => {
                                    setLimit(newLimit)
                                    setPage(1)
                                }}
                                onChangePage={(newPage) => {
                                    setPage(newPage)
                                }}
                            />
                        :
                            <h4 className='mt-4'>{t('admin.logs.thereisnotlogs')}</h4>
                    }
                </Col>
            </Row>
        </Container>
	)
}